import { render, staticRenderFns } from "./resourceMenu.vue?vue&type=template&id=1ff13084&scoped=true&"
import script from "./resourceMenu.vue?vue&type=script&lang=js&"
export * from "./resourceMenu.vue?vue&type=script&lang=js&"
import style0 from "./resourceMenu.vue?vue&type=style&index=0&id=1ff13084&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff13084",
  null
  
)

export default component.exports